<template>
  <Header></Header>
  <router-view :style="{ minHeight: containerHeight + 'px', marginTop: '78px' }"></router-view>
  <Footer></Footer>
</template>

<script setup>
import { defineComponent, onMounted, onUnmounted, ref } from 'vue';

import Footer from '@/components/Footer.vue';
import Header from '@/components/Header.vue';

const containerHeight = ref(0);

const updateContainerHeight = () => {
  containerHeight.value = window.innerHeight - 100;
};

onMounted(() => {
  updateContainerHeight();
  window.addEventListener('resize', updateContainerHeight);
});

onUnmounted(() => {
  window.removeEventListener('resize', updateContainerHeight);
});
</script>

<style lang="less"></style>
